"use client";

import clsx from "clsx";
import Image from "next/image";
import { forwardRef, type ButtonHTMLAttributes } from "react";
import { GAIL_ASSISTANT_PANEL_TIMING } from "@/utils/chat/gailGptLauncher";
import styles from "./GailGptLauncher.module.css";

const GailAssistantLauncherButton = forwardRef<
  HTMLButtonElement,
  ButtonHTMLAttributes<HTMLButtonElement>
>(function GailAssistantLauncherButton({ className, style, ...props }, ref) {
  return (
    <button
      {...props}
      ref={ref}
      type="button"
      className={clsx(
        "flex h-12 w-12 shrink-0 items-center justify-center rounded-lg border-[1.5px] border-transparent text-text_primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-button_primary",
        styles.launcher,
        className
      )}
      style={{ transitionTimingFunction: GAIL_ASSISTANT_PANEL_TIMING, ...style }}
    >
      <Image src="/icons/gail2-icon-blue.svg" alt="" width={22} height={22} />
    </button>
  );
});

export default GailAssistantLauncherButton;
